import './plugins/jquery.js';

import {CONFIG} from './config.js';

import './modules/window_info.js';
import './modules/resize_end.js';
import './modules/pcsp.js';
import './modules/viewport_fit.js'
import './modules/smooth_scroll.js'
import './modules/anchor_jump.js'

/*******************************************************************************
pcspChanged
*******************************************************************************/
$(window).on('pcspChanged', function(event) {
	event.preventDefault();
	import('./modules/gnav.js').then(({gNav}) => {
		gNav.isOpen && gNav.close()
	})
});


/*******************************************************************************
click event
*******************************************************************************/
//gNav開閉
$(document).on('click', '.gHeader_navBtn', function(event) {
	event.preventDefault();
	import('./modules/gnav.js').then(({gNav}) => {
		gNav.toggle()
	})
});

//overlay click
$(document).on('click', '.overlay', function(event) {
	event.preventDefault();
	import('./modules/gnav.js').then(({gNav}) => {
		gNav.close()
	})
});